export const generateAddend = (digitType) => {
  let min, max;

  switch (digitType) {
    case "Single":
      min = 1;
      max = 9;
      break;

    case "Double":
      min = 11;
      max = 99;
      break;

    case "Triple":
      min = 101;
      max = 999;
      break;

    default:
      min = 1;
      max = 9;
  }

  return Math.floor(Math.random() * (max - min + 1)) + min;
};